import gql from 'graphql-tag';

const AllTasks = gql`
  query TasksConnection($filter: TaskFilter!, $after: String, $before: String, $first: Int, $last: Int $orderBy: [[String]] = [["created_at","asc"]]) {
    tasksConnection(filter: $filter, after: $after, before: $before, first: $first, last: $last, orderBy: $orderBy) {
      totalCount
       pageInfo {
         startCursor
         endCursor
         hasNextPage
         hasPreviousPage
       }
      edges {
       cursor
       node {
         id
         claimId
         status
         description
         priority
         createdAt
         taskType {
           id
           name
           description
         }
         user {
           id
           name
           surname
           email
         }
         claim {
           id
           state
           crmState
         }
         emailMessage {
           id
           senderType
         }
       }
      }
    }
  }
`

export { AllTasks }



// WEBPACK FOOTER //
// ./src/queries/AllTasks.js